export interface CaseStudy {
  name: string;
  industry: string;
  color: string;
  logoDark: string;
  logoLight: string;
  url: string;
  description: string;
  contact: string;
}

export const CASES: CaseStudy[] = [
  {
    name: 'Fresko',
    industry: 'Servicio técnico de aires acondicionados',
    color: '#10B981',
    logoDark: '/images/case-fresko-light.png',
    logoLight: '/images/case-fresko-light.png',
    url: 'https://fresko.com.ar',
    description: 'Automatización completa de la operación: agendamiento inteligente, atención al cliente 24/7 por WhatsApp, facturación automática y seguimiento post-servicio.',
    contact: 'Nicolás Alí',
  },
  {
    name: 'Block Builders',
    industry: 'Tecnología',
    color: '#3B82F6',
    logoDark: '/images/case-blockbuilders-dark.png',
    logoLight: '/images/case-blockbuilders-light.png',
    url: 'https://block-builders.tech',
    description: 'Automatización de toda la comunicación con clientes y procesos internos. Integraciones entre plataformas y flujos de trabajo optimizados.',
    contact: '',
  },
  {
    name: 'BioConfluence',
    industry: 'Vida / Biotech',
    color: '#8B5CF6',
    logoDark: '/images/case-bioconfluence-dark.png',
    logoLight: '/images/case-bioconfluence-light.png',
    url: 'https://bioconfluence.com',
    description: 'Gestión automatizada de un newsletter científico: curaduría de contenido con IA, armado, envío segmentado y seguimiento de métricas.',
    contact: '',
  },
];

export interface Service {
  iconName: string;
  title: string;
  tagline: string;
  desc: string;
  wa: string;
}

export const SERVICES: Service[] = [
  {
    iconName: 'Bot',
    title: 'Agentes IA Conversacionales',
    tagline: 'Tu equipo de atención que nunca duerme',
    desc: 'Agentes que atienden consultas, agendan turnos, procesan pagos y escalan a humanos. En WhatsApp, Instagram, Facebook y web.',
    wa: 'Hola! Me interesa un agente IA conversacional para mi negocio. Podemos hablar?',
  },
  {
    iconName: 'Zap',
    title: 'Automatización de Procesos',
    tagline: 'Eliminá las tareas que te roban horas',
    desc: 'Flujos automáticos que conectan todo tu stack. Desde notificaciones hasta pipelines complejos con n8n, Make y Zapier.',
    wa: 'Hola! Necesito automatizar procesos en mi empresa. Podemos coordinar una llamada?',
  },
  {
    iconName: 'Link2',
    title: 'Integraciones entre Sistemas',
    tagline: 'Que tus herramientas se hablen entre sí',
    desc: 'CRM, facturación, calendarios, e-commerce, ERPs. Un ecosistema conectado donde la información fluye sin intervención manual.',
    wa: 'Hola! Quiero integrar mis sistemas. Podemos hablar?',
  },
  {
    iconName: 'BarChart3',
    title: 'Portal de Gestión con IA',
    tagline: 'Tu centro de control inteligente',
    desc: 'Plataforma completa: conversaciones, agenda, catálogo, facturación, finanzas y un agente IA que opera por vos.',
    wa: 'Hola! Me interesa el portal de gestión con IA. Podemos hablar?',
  },
  {
    iconName: 'Mail',
    title: 'Agentes para Email',
    tagline: 'Emails que se responden solos',
    desc: 'Agentes que leen, clasifican, priorizan y responden emails. Integrados con tu dominio, CRM y flujos existentes.',
    wa: 'Hola! Necesito un agente de IA para gestionar emails. Podemos hablar?',
  },
  {
    iconName: 'Smartphone',
    title: 'Meta Business Suite',
    tagline: 'WhatsApp, Instagram y Facebook a escala',
    desc: 'WhatsApp Business API, Instagram DM y Facebook Messenger con tu cuenta Meta verificada. Mensajería oficial y automatizada.',
    wa: 'Hola! Necesito conectar mi negocio con Meta. Podemos hablar?',
  },
];

export interface FaqItem {
  question: string;
  answer: string;
}

export const FAQ_ITEMS: FaqItem[] = [
  {
    question: 'Qué es John Fox y cómo puede ayudar a mi negocio?',
    answer: 'John Fox es una empresa de automatización inteligente. Construimos agentes de IA, integramos tus sistemas, automatizamos procesos y ofrecemos un portal de gestión con IA incluido. Desde soluciones a medida hasta nuestra plataforma lista para usar, nos adaptamos a lo que tu negocio necesita.',
  },
  {
    question: 'Cuánto tiempo tarda la implementación?',
    answer: 'Depende de la complejidad. Una automatización simple puede estar lista en 48-72 horas. Un sistema completo con agentes, integraciones y portal toma entre 2 y 4 semanas. Siempre arrancamos por lo que más impacto genera en tu operación.',
  },
  {
    question: 'Necesito conocimientos técnicos para usar las soluciones?',
    answer: 'No. Todo lo que construimos está diseñado para que lo use cualquier persona de tu equipo sin formación técnica. Además, te capacitamos y te damos soporte continuo.',
  },
  {
    question: 'Qué pasa si no funciona o no me sirve?',
    answer: 'Antes de implementar, validamos juntos el alcance y los resultados esperados. Si algo no funciona como acordamos, lo ajustamos sin costo adicional. Tu inversión está protegida.',
  },
  {
    question: 'Cómo es el soporte después de la implementación?',
    answer: 'Tenés soporte continuo por WhatsApp. Monitoreamos tus automatizaciones, resolvemos incidencias y optimizamos los flujos a medida que tu negocio crece. No te dejamos solo después de implementar.',
  },
  {
    question: 'Puedo integrar herramientas que ya uso?',
    answer: 'Sí. Trabajamos con más de 50 plataformas: CRMs, e-commerce, facturación, calendarios, redes sociales, pasarelas de pago y más. Si tu herramienta tiene API, la conectamos.',
  },
];

export interface Integration {
  name: string;
  color: string;
}

export const INTEGRATIONS: Integration[] = [
  { name: 'WhatsApp', color: '#25D366' },
  { name: 'Instagram', color: '#E4405F' },
  { name: 'Facebook', color: '#1877F2' },
  { name: 'Messenger', color: '#0084FF' },
  { name: 'Google Calendar', color: '#4285F4' },
  { name: 'Gmail', color: '#EA4335' },
  { name: 'MercadoPago', color: '#009EE3' },
  { name: 'Stripe', color: '#635BFF' },
  { name: 'Shopify', color: '#96BF48' },
  { name: 'WooCommerce', color: '#96588A' },
  { name: 'HubSpot', color: '#FF7A59' },
  { name: 'Salesforce', color: '#00A1E0' },
  { name: 'Slack', color: '#4A154B' },
  { name: 'Google Sheets', color: '#0F9D58' },
  { name: 'n8n', color: '#EA4B71' },
  { name: 'Make', color: '#6D00CC' },
  { name: 'Zapier', color: '#FF4F00' },
  { name: 'ARCA', color: '#2E86AB' },
  { name: 'Notion', color: '#000000' },
  { name: 'Trello', color: '#0052CC' },
  { name: 'Jira', color: '#0052CC' },
  { name: 'Twilio', color: '#F22F46' },
  { name: 'OpenAI', color: '#10A37F' },
  { name: 'Google Drive', color: '#4285F4' },
];

export const STEPS = [
  {
    number: '01',
    title: 'Hablamos',
    desc: 'Nos contás cómo opera tu negocio hoy, qué te duele y dónde querés llegar. Sin compromiso.',
  },
  {
    number: '02',
    title: 'Diseñamos e implementamos',
    desc: 'Armamos la solución a medida: agentes, automatizaciones, integraciones. Vos hacés el onboarding, nosotros construimos.',
  },
  {
    number: '03',
    title: 'Tu negocio opera',
    desc: 'Todo funciona. Tus clientes se atienden solos, tus procesos corren automáticos y vos te enfocás en crecer.',
  },
];

export const TRUST_QUOTE = {
  headline: 'El mundo cambió...',
  title: 'Todos los procesos están siendo reinventados.',
  body: 'Automatizar no es una ventaja competitiva. Es el costo de seguir en el mercado.',
  author: 'Rodrigo Castro',
  role: 'Fundador, John Fox',
};

export const SOCIAL = {
  whatsapp: 'https://wa.me/5491158784808',
  facebook: 'https://www.facebook.com/i.love.john.fox',
  instagram: 'https://instagram.com/john.fox.click',
  linkedin: 'https://linkedin.com/company/ilovejohnfox',
  email: 'contacto@johnfox.click',
};

export const WA_NUMBER = '5491158784808';
export const FORM_WEBHOOK = 'https://agent.johnfox.click/webhook/registro_diciembre';
export const PORTAL_LOGIN_URL = 'https://portal.johnfox.click/auth/login';
